import * as THREE from 'three'

// Procedural cast-metal matcap for the near-field letterpress glyphs
// (FOUNDATION §10: matcap = cast-metal specular with zero lights).
export function makeMatcap(size = 256): THREE.Texture {
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = size
  const ctx = canvas.getContext('2d')!
  const c = size / 2

  const base = ctx.createRadialGradient(c * 0.8, c * 0.7, c * 0.1, c, c, c)
  base.addColorStop(0, '#8d979e')
  base.addColorStop(0.55, '#4a545c')
  base.addColorStop(0.85, '#22282d')
  base.addColorStop(1, '#14181c')
  ctx.fillStyle = base
  ctx.fillRect(0, 0, size, size)

  // specular hotspot, upper-left
  const spec = ctx.createRadialGradient(c * 0.55, c * 0.45, 1, c * 0.55, c * 0.45, c * 0.5)
  spec.addColorStop(0, 'rgba(255,255,255,0.9)')
  spec.addColorStop(0.25, 'rgba(230,238,242,0.35)')
  spec.addColorStop(1, 'rgba(255,255,255,0)')
  ctx.fillStyle = spec
  ctx.fillRect(0, 0, size, size)

  // rim light, lower-right
  const rim = ctx.createRadialGradient(c * 1.5, c * 1.5, c * 0.2, c * 1.4, c * 1.4, c * 0.9)
  rim.addColorStop(0, 'rgba(190,205,214,0.5)')
  rim.addColorStop(1, 'rgba(190,205,214,0)')
  ctx.fillStyle = rim
  ctx.fillRect(0, 0, size, size)

  const tex = new THREE.CanvasTexture(canvas)
  tex.minFilter = THREE.LinearFilter
  return tex
}
